import React from 'react';
import PT from 'prop-types';
import cn from 'classnames';

import DropdownMenu from 'Components/Admin/DropdownMenu/DropdownMenu';
import TriangleIcon from 'Components/Admin/TriangleIcon/TriangleIcon';

const PageSizeDropdown = React.memo(({pageSize, pageSizeOptions = [], onPageSizeChange}) => {
  const renderDropdownButton = () => {
    return (
        <div className="pagination-dropdown__btn">
          <span className="pagination-dropdown__btn-label">{pageSize}</span>
          <span>
            <TriangleIcon direction="down" className="pagination-dropdown__btn-icon"/>
          </span>
        </div>
    );
  };

  const handleSelectOption = (pageSize) => onPageSizeChange(pageSize);

  const isOptionActive = (option) => +option === +pageSize;

  return (
      <div className="pagination-dropdown">
        <span>Showing entries</span>
        <DropdownMenu
            triggerButtonRender={renderDropdownButton}
            binding="top"
            dropdownClassName="pagination-dropdown__dropdown"
        >
          {pageSizeOptions.map(option => (
              <li
                  key={option}
                  onClick={handleSelectOption.bind(null, option)}
                  className={cn(
                      'pagination-dropdown__option',
                      {'pagination-dropdown__option_active': isOptionActive(option)},
                  )}
              >
                {option}
              </li>
          ))}
        </DropdownMenu>
        <span>per page</span>
      </div>
  );
});

PageSizeDropdown.PropsType = {
  pageSize: PT.string,
  pageSizeOptions: PT.arrayOf(PT.number),
  onPageSizeChange: PT.func,
};

export default PageSizeDropdown;
